import { IAreaSelectionUtil } from "Interfaces/Utils/IAreaSelectionUtil";
import { IChipUtil } from "Interfaces/Utils/IChipUtil";
import { inject, injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import Types from "ServiceProvider/Types";

@injectable()
export class ChipUtil implements IChipUtil {

    private readonly areaSelectionUtil: IAreaSelectionUtil;
    public static MAX_PATH_LENGTH: number = 50;

    constructor(@inject(Types.IAreaSelectionUtil) areaSelectionUtil: IAreaSelectionUtil) {
        this.areaSelectionUtil = areaSelectionUtil;
    }

    public getChipString(path: string[]): string {
        return path.join(" -> ");
    }

    public getAreaChip(area: Area, areas: Area[], filteredArea?: Area, maxPathLength?: number): any {
        // Get the path of the area that is filtered
        let filteredPath: string[] = [];
        if (filteredArea) {
            filteredPath = this.areaSelectionUtil.getTreeNamesByArea(filteredArea, areas);
        }

        // Get the path of the area of the state
        let path = this.areaSelectionUtil.getTreeNamesByArea(area, areas);
        // Remove the filtered path from the area path
        path.splice(0, filteredPath.length);

        // Get tooltipstring for area path
        const tooltip = this.getChipString(path);
        // Elipse the area path if it is too long
        if (this.getChipString(path).length > (maxPathLength || ChipUtil.MAX_PATH_LENGTH)) {
            if (path.length > 2) {
                path = [path[0], "...", path[path.length - 1]];

                if (this.getChipString(path).length > (maxPathLength || ChipUtil.MAX_PATH_LENGTH)) {
                    path[0] = path[0].substring(0, 10) + "...";
                }
            }
        }

        return { path, tooltip };
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/Chip/Util/ChipUtil.ts